import { useCan } from "components";
import { useTypedQuery } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { QuestionsDashboardQueryKeys } from "modules/QuestionsDashboard/queryKeys";
import { sortQuestionsByNewest } from "modules/QuestionsDashboard/util";
import { ApiInstance } from "utils/Api";

export const useDefaultQuestionsQuery = () => {
  const canListQuestions = useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.Questions);

  return useTypedQuery({
    queryKey: QuestionsDashboardQueryKeys.defaultQuestions,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, {}, baseUrl)).data.questions,
    select: sortQuestionsByNewest,
    enabled: canListQuestions
  });
};
